<template>
  <ul :class="[{'main-nav__submenu--open': open }, {'main-nav--save-in-progress': saveInProgress}]" :key="hotelSettings.hotel.id" class="main-nav__submenu">
    <router-link v-if="hasRole('ROLE_SYSADMIN')" :to="{ name: 'hotels' }" tag="li" exact>
      <li>
        <a href="#">{{ $t('menu.admin.tenants') }}</a>
      </li>
    </router-link>
    <router-link v-if="isSystemTenant() && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" :to="{ name: 'globalFeatureToggle' }" tag="li" exact>
      <li>
        <a href="#">Global Feature Toggles 🔒</a>
      </li>
    </router-link>
    <router-link v-if="hasRole('ROLE_ADMIN')"
                 :to="{ name: 'hotel' }"
                 :class="{'main-nav__hr': hasRole('ROLE_SYSADMIN')}"
                 tag="li"
                 exact>
      <li>
        <a href="#">{{ $t('menu.admin.hotelBaseData') }}</a>
      </li>
    </router-link>
    <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'invoiceSettings' }" tag="li" exact>
      <li>
        <a href="#">{{ $t('menu.admin.invoiceStationery') }}</a>
      </li>
    </router-link>
    <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'hotelSettings' }" tag="li" exact>
      <li>
        <a href="#">{{ $t('menu.admin.generalSettings') }}</a>
      </li>
    </router-link>
    <template v-if="hotelSettings.hotel.whiteLabel === 'Hotelmeister'">
      <router-link v-if="hasRole('ROLE_FINANCIAL_REPORTS') && !isEmpty(hotelSettings.details.additionalFields.SEVDESK_CUSTOMER_NUMBER)"
                   :class="['main-nav__hr']"
                   :to="{ name: 'hotelHotelmeisterInvoices' }"
                   tag="li"
                   exact>
        <li>
          <a href="#">{{ $t('menu.admin.hotelmeisterInvoices') }}</a>
        </li>
      </router-link>
    </template>
    <template v-if="!hotelSettings.details.deactivated">
      <router-link v-if="hasRole('ROLE_ADMIN')"
                   :to="{ name: 'taxes' }"
                   tag="li"
                   class="main-nav__hr"
                   exact>
        <li>
          <a href="#">{{ $t('menu.admin.taxes') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasLicense('TaxSet') && hasRole('ROLE_ADMIN')"
                   :to="{ name: 'taxSets' }"
                   tag="li"
                   exact>
        <li>
          <a href="#">{{ $t('menu.admin.taxSets') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'ageCategories' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.ageCategories') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'inHouseServices' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.inHouseServices') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'roomTypes' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.roomTypes') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'rooms' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.rooms') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'mealPlans' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.mealPlans') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'policies' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.policies') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_RATE_ADMIN'])" :to="{ name: 'ratePlans' }" tag="li" exact>
        <li class="main-nav__hr">
          <a href="#">{{ $t('menu.admin.ratePlans') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_RATE_ADMIN'])" :to="{ name: 'seasons' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.seasons') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_RATE_ADMIN'])" :to="{ name: 'seasonCalendars' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.seasonCalendars') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_RATE_ADMIN'])" :to="{ name: 'seasonRateEditorRatePlans' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.seasonRates') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_ADMIN', 'ROLE_RATE_ADMIN']) && hasLicense('DiscountCode')" :to="{ name: 'discountCodes' }" tag="li" exact>
        <li class="main-nav__hr">
          <a href="#">{{ $t('menu.admin.discountCodes') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'templates' }" tag="li" exact>
        <li class="main-nav__hr">
          <a href="#">{{ $t('menu.admin.templates') }}</a>
        </li>
      </router-link>
      <router-link :to="{ name: 'users' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.users') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasRole('ROLE_ADMIN') || hasRole('ROLE_INTERFACES')" :to="{ name: 'interfaces' }" tag="li" exact>
        <li class="main-nav__hr">
          <a href="#">{{ $t('menu.admin.interfaces') }}</a>
        </li>
      </router-link>
      <template v-if="hasLicense('InterfaceCmConnectCX') && (hasRole('ROLE_ADMIN') || hasRole('ROLE_INTERFACES')) && (['Hotelmeister','AllInOne'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))">
        <router-link v-for="itCx in hotelSettings.interfaces.connectCx"
                     :key="`${itCx.id}-bookings`"
                     :to="{ name: 'interfaces.connectCXbookings', params: { configId: itCx.id } }"
                     tag="li"
                     exact>
          <li>
            <a href="#">Connect.CX Bookings<template v-if="!isEmpty(itCx.name)">&nbsp;({{ itCx.name }})</template></a>
          </li>
        </router-link>
      </template>
      <router-link v-if="hasLicense('InterfaceCmConnectS') && suApiVersion === 'v1' && (hasRole('ROLE_ADMIN') || hasRole('ROLE_INTERFACES')) && (['Hotelmeister','Rainmaker'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))" :to="{ name: 'interfaces.connectSbookings' }" tag="li" exact>
        <li>
          <a href="#">Connect.S Bookings</a>
        </li>
      </router-link>
      <router-link v-if="hasLicense('InterfaceCmConnectS') && suApiVersion === 'v2' && (hasRole('ROLE_ADMIN') || hasRole('ROLE_INTERFACES')) && (['Hotelmeister','Rainmaker'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))" :to="{ name: 'interfaces.connectSbookingsV2' }" tag="li" exact>
        <li>
          <a href="#">Connect.S Bookings</a>
        </li>
      </router-link>
      <router-link v-if="hasLicense('InterfaceCmConnectS') && (hasRole('ROLE_ADMIN') || hasRole('ROLE_INTERFACES')) && (['Hotelmeister','Rainmaker'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))" :to="{ name: 'interfaces.connectSreviews' }" tag="li" exact>
        <li>
          <a href="#">Connect.S Reviews</a>
        </li>
      </router-link>
      <template v-if="!isNil(hotelSettings) && !isNil(hotelSettings.details) && hotelSettings.details.countryCode === 'AT'">
        <template v-if="hasLicense('EU_AT_Registrierkasse')">
          <router-link v-if="hasRole('ROLE_ADMIN') || hasRole('ROLE_USER')" :to="{ name: 'registrierkasse.at' }" tag="li" exact>
            <li>
              <a href="#">{{ $t('menu.admin.registrierkasseAT') }}</a>
            </li>
          </router-link>
        </template>
      </template>
      <template v-if="!isNil(hotelSettings) && !isNil(hotelSettings.details) && hotelSettings.details.countryCode === 'DE'">
        <template v-if="hasLicense('EU_DE_Registrierkasse')">
          <router-link v-if="hasRole('ROLE_ADMIN') || hasRole('ROLE_USER')" :to="{ name: 'registrierkasse.de' }" tag="li" exact>
            <li>
              <a href="#">{{ $t('menu.admin.registrierkasseDE') }}</a>
            </li>
          </router-link>
        </template>
        <template v-else-if="hasLicense('Payments')">
          <router-link v-if="hasRole('ROLE_ADMIN') || hasRole('ROLE_USER')" :to="{ name: 'enableKassenSichV' }" tag="li" exact>
            <li>
              <a href="#">{{ $t('menu.admin.registrierkasseDE') }}</a>
            </li>
          </router-link>
        </template>
      </template>
      <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'guestCategories' }" tag="li" exact>
        <li class="main-nav__hr">
          <a href="#">{{ $t('menu.admin.guestCategories') }}</a>
        </li>
      </router-link>
      <router-link v-if="hasAnyRole(['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION', 'ROLE_ADMIN'])" :to="{ name: 'inventory' }" tag="li" exact>
        <li>
          <a href="#">{{ $t('menu.admin.inventory') }}</a>
        </li>
      </router-link>
      <template v-if="hasLicense('Messaging')">
        <router-link v-if="hasRole('ROLE_ADMIN')" :to="{ name: 'messagingSequence', params: { messagingSequenceType: 'RoomReservation' } }" tag="li" exact>
          <li>
            <a href="#">{{ $t('menu.admin.messagingSequence') }}</a>
          </li>
        </router-link>
      </template>
      <router-link v-if="hasRole('ROLE_SYSADMIN')" :to="{ name: 'inventoryLog' }" tag="li" exact>
        <li>
          <a href="#">Inventory Logs 🔒</a>
        </li>
      </router-link>
      <router-link v-if="(isProduction && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')) || (!isProduction && hasRole('ROLE_SYSADMIN'))" :to="{ name: 'csvImport' }" tag="li" exact>
        <li>
          <a href="#">CSV Import 🔒</a>
        </li>
      </router-link>
      <template v-if="(hasRole('ROLE_ADMIN') && hasAnyLicense(['OnlineBooking', 'Kiosk', 'InterfaceMeldeblatt', 'Privacy'])) || hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
        <router-link :to="{ name: 'privacyPolicies' }" tag="li" exact>
          <li>
            <a href="#">{{ $t('menu.admin.privacyPolicies') }} 🔒</a>
          </li>
        </router-link>
      </template>
      <div style="padding-bottom: 200px;"></div>
      <!--
              <li>
                <a href="#">Hotel</a>
              </li>
              <li>
                <a href="">Preise</a>
              </li>
              </li>
              <li class="main-nav__hr">
                <a href="#">Zimmerstatus</a>
              </li>
              <li>
                <a href="#">Benutzer</a>
              </li>
              <li>
                <a href="#">Vorlagen</a>
              </li>
              <li>
                <a href="#">Datenschutzerklärung</a>
              </li>
              <li>
                <a href="#">Opt-Ins/Opt-Outs</a>
              </li>
              <li>
                <a href="#">Gästekategorien</a>
              </li>
              <li>
                <a href="#">Registrierkasse</a>
              </li>
              <li>
                <a href="#">Schnittstellen</a>
              </li>
              -->
    </template>
  </ul>
</template>

<script>

import { isEmpty, isNil, uniq } from 'lodash';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';
import { isProduction } from '@/lib/util/isProduction';

export default {
  name: 'SettingsSubNav',

  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visibleRateplan: false,
      visiblePackage: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    this.visibleRateplan = false;
    this.visiblePackage = false;

    next();
  },

  computed: {
    saveInProgress: function () {
      return this.$store.getters['save/saveInProgress'];
    },
  },

  created: function () {
  },

  mounted: function () {
  },

  methods: {
    isEmpty,
    isProduction() {
      return isProduction;
    },
    isSystemTenant() {
      try {
        return ['hotelmeister', 'system'].includes(this.hotelSettings.tenant.subdomain.toLowerCase());
      } catch (e) {
        return false;
      }
    },
    openUrl: function (event, url) {
      event.preventDefault();
      event.stopPropagation();
      window.openOldUI(
        this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        url,
        window.getToken(this.$route.params.hotelId),
        this.$shortLocale === 'de' ? this.$shortLocale : 'en',
      );
    },
    env: function (name) {
      return process.env[name];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/SettingsSubNav.vue